import React from 'react';
import FormulaFieldProto from '../formula-proto';

export default function renderFormulaInView(id, props) {
    return <FormulaFieldProto renderMode="view" id={id} {...props} />;
}